<template lang="pug">
  .step-one-wrapper
    .change-title 选择模板
      span (选择后，可在下一步对模板内容进行编辑修改)
    .section-filter
      .field-group.is-horizontal
        .field.name_keyword-wrapper
          label.label 关键字搜索
          custom-input(v-model="filter_data.keyword", placeholder="请输入模板标题", @keyupEnter="search")
        .field.name_keyword-wrapper
          label.label 模板分类
          custom-select(v-model="filter_data.category", :list="category_type", nameField="title")
        .field
          a.button.primary(@click="search") 搜索
        .field
          a.button(@click="reset") 重置
    .section-layout
      .content-box
        .content-wrapper.list-wrapper(v-if="list && list.length")
          .table-wrapper
            table.table
              thead
                tr
                  td(width="120")
                  td(width="120") 封面图
                  td(width="260") 模板标题
                  td(width="200") 模板分类
                  td(width="100") 操作
              tbody(v-if="list.length")
                tr(v-for="(item, index) in list")
                  td
                    .radio
                      input(type="radio", :value="item.id", v-model="template_seleted")
                      label
                  td
                    .icon-img(v-if="item.cover_img")
                      img(:src="item.cover_img")
                    .simple-null(v-else) --
                  td
                    .simple-td(v-text="item.title")
                  td
                    .simple-td(v-text="item.category_title")
                  td
                    a(@click="showAddModel(item)") 海报预览
          pagination(:pagination-data="pagination_data", @input="paging")
        .empty-page-box(v-else)
          empty-page(:tip="'很抱歉，暂无可使用的模板，请联系你的系统客服人员！'")
      .btn-wrapper
          .button-group
            a.button.large(@click="goBack") 返回
            a.button.primary.large(v-if="list && list.length", @click="next") 下一步
      //- 海报预览
      slide-out-modal(v-if="slideVisible" @input="showAddModel")
        view-poster(:poster_info="poster_info")
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '@/mixins/modules/Content'
import CustomInput from '@/components/generics/form/CustomInput'
import CustomSelect from '@/components/generics/form/CustomSelect'
import EmptyPage from '@/components/generics/EmptyPage'
import Pagination from '@/components/generics/Pagination'
import SlideOutModal from '@/components/generics/SlideOutModal'
import ViewPoster from '@/components/content/modal/ViewPoster'
import utils from '@/mixins/utilities/utils' // changeDateTime（时间戳转日期）
export default {
  name: 'ContentTemplateOne',
  mixins: [Api, utils],
  components: {
    CustomInput,
    CustomSelect,
    EmptyPage,
    Pagination,
    SlideOutModal,
    ViewPoster,
  },
  data () {
    return {
      // 模板类型
      category_type: [{ title: '全部', id: '' }],
      list: [
        // { title: '店庆模板一', category_title: '店庆', id: 1, cover_img: 'https://chedian-oss1.vchangyi.com/test/images/other/15852791746940.png?imageMogr2/auto-orient' },
      ],
      filter_data: {
        keyword: '',
        category: { title: '全部', id: '' },
      },
      pagination_data: {
        current_page: 1,
        per_page: 20,
        last_page: 2,
        total: 0,
      },
      slideVisible: false, // 海报预览弹框显示状态
      poster_info: {}, // 海报预览信息
      template_seleted: '', // 选中模板信息
    }
  },
  computed: {
    ...mapGetters({
      currentStore: 'currentStore',
    }),
  },
  methods: {
    // 海报预览模态框
    showAddModel (item) {
      if (!this.slideVisible) {
        let posterInfo = JSON.parse(JSON.stringify(item))
        posterInfo.start_time = this.changeDateTime(item.start_time).trim().replace(/-/g, '.')
        posterInfo.end_time = this.changeDateTime(item.end_time).trim().replace(/-/g, '.')
        this.poster_info = posterInfo
      }
      this.slideVisible = !this.slideVisible
    },

    // 返回列表页
    goBack () {
      this.$emit('goback')
    },

    // 搜索
    search () {
      this.pagination_data.current_page = 1
      this.getActivityStoreBossList()
    },

    // 重置
    reset () {
      this.pagination_data.current_page = 1
      this.category_type = [{ title: '全部', id: '' }]
      this.filter_data = {
        keyword: '',
        category: { title: '全部', id: '' },
      }
      this.getTemplateCategory()
      this.getActivityStoreBossList()
    },

    /**
     * 分页处理
     * @status  分页的状态
     */
    paging (state) {
      this.pagination_data = state
      this.getActivityStoreBossList()
    },

    // 下一步
    next (step) {
      // 验证是否选择模板
      if (this.template_seleted === '') {
        this.$store.dispatch('showMessage', {
          autoClose: true,
          type: 'failure',
          title: '提示',
          content: '请先选择一个模板！',
        })
        return
      }
      this.$emit('nextstep', 2, this.template_seleted)
    },

    // 获取模板分类列表
    async getTemplateCategory () {
      try {
        const { response, result } = await this.GetTemplateCategoryApi()
        if (response.status === 200 && result.code === 0) {
          this.category_type = [
            { title: '全部', id: '' },
            ...result.data,
          ]
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取模板分类列表失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取模板分类列表失败',
          content: `错误：${err}`,
        })
      }
    },

    // 中央活动库列表（模板活动列表）
    async getActivityStoreBossList () {
      try {
        const { response, result } = await this.GetActivityStoreBossListApi({
          keyword: this.filter_data.keyword,
          category_id: this.filter_data.category.id,
          page: this.pagination_data.current_page,
          per_page: this.pagination_data.per_page,
        })
        if (response.status === 200 && result.code === 0) {
          this.list = result.data
          this.pagination_data = result.meta
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取中央活动库列表数据失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取中央活动库列表数据失败',
          content: `错误：${err}`,
        })
      }
    },
  },
  mounted () {
    this.getTemplateCategory()
    this.getActivityStoreBossList()
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.step-one-wrapper
  display flex
  flex-direction column
  overflow scroll
.section-layout
  overflow scroll
.change-title
  min-height 40px
  padding 0 32px
  font-size 12px
  position relative
  display flex
  align-items center
  // background #e8e9eb
  &::before
    content '*'
    color #f56c6c
    position relative
    left -15px
    top 3px
    font-size 15px
  span
    color red
.content-wrapper
  flex-grow 0
.content-box
  display flex
  flex-direction column
  flex-grow 1
  // height calc(100% - 40px)
.icon-img
  height 36px
.icon-img img
  width 36px
  height 36px
.empty-page-box
  height 300px
  display flex
.btn-wrapper
  padding 25px
  display flex
  justify-content center
  align-items center
  a
    width 120px
// 海报预览
.poster
  height 400px
  border 1px solid #f1f1f1
.content-title
  text-align center
  margin-top 20px
  font-size 20px
// 活动信息
.content-info
  color #353535
  margin-top 30px
  padding 0 20px
  .content-desc
    padding 10px 0
</style>



// WEBPACK FOOTER //
// src/components/content/modal/ContentTemplateOne.vue